<template>
  <input
    v-show="$parent.inputShown"
    :id="pickerId"
    ref="suggestInput"
    v-model="$parent.text"
    role="combobox"
    :aria-describedby="ariaDescribedby"
    :aria-activedescendant="ariaActivedescendant"
    :aria-autocomplete="'list'"
    :name="$parent.pickerName"
    :maxlength="$parent.maxlength"
    :placeholder="$parent.placeholder"
    :readonly="$parent.readonly"
    :aria-required="$parent.required"
    :title="$parent.title"
    :type="type"
    autocomplete="off"
    :aria-expanded="$parent.showSuggestions"
    :aria-controls="ariaControls"
    aria-haspopup="listbox"
    :aria-label="ariaLabel"
    @input="$parent.onInput"
    @focus="$parent.onInputFocus"
    @blur="$parent.onInputBlur"
    @keydown.down.prevent="$parent.highlightNext"
    @keydown.up.prevent="$parent.highlightPrev"
    @keydown.enter.prevent="$parent.selectHighlighted"
    @keydown.esc="$parent.closeSuggestions"
  />
</template>

<script>
export default {
  name: 'PickerInput',
  props: {
    pickerId: {
      type: String,
      required: true,
    },
    ariaDescribedby: {
      type: String,
      required: true,
    },
    ariaActivedescendant: {
      type: String,
      default: null,
    },
    ariaControls: {
      type: String,
      default: null,
    },
    ariaLabel: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
  },
  mounted() {
    this.$el.inputElement = this.$refs.suggestInput;
  },
  methods: {
    focus() {
      this.$refs.suggestInput?.focus();
    },
    getBoundingClientRect() {
      return this.$refs.suggestInput?.getBoundingClientRect();
    },
    hasAttribute(attr) {
      return this.$refs.suggestInput?.hasAttribute(attr);
    },
    getAttribute(attr) {
      return this.$refs.suggestInput?.getAttribute(attr);
    },
    removeAttribute(attr) {
      this.$refs.suggestInput?.removeAttribute(attr);
    },
  },
};
</script>
